import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link, useParams } from 'react-router-dom';
import { getCase, updateCase } from '../../../actions/case-actions';
import { formatDate } from '../../../actions/global-actions';
import { BsFillTrashFill } from "react-icons/bs";

function CommentsList(){
    const currentLink = "/casos/historial";
    const dispatch = useDispatch();
    const [comments, setComments] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const params = useParams();
    const [currentData, setCurrentData] = useState({});

    useEffect(() => {
        const getFunction = (response) => {
            if(response.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: response.message
                });
            }else{
                //console.log(response.data);
                let type = response.data.caseType;
                response.data.caseType = type.charAt(0).toUpperCase() + type.slice(1);
                response.data.clientText = `${response.data.client.clientId.firstName} ${response.data.client.clientId.lastName}`;

                for (let index = 0; index < response.data.comments.length; index++) {
                    response.data.comments[index].date = new Date(response.data.comments[index].date);
                }
                
                response.data.comments.sort((a, b) => b.date - a.date)

                setCurrentData(response.data);
                setComments(response.data.comments);
            }
        }

        if (loadData) {
            setLoadData(false);
            setComments([]);
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, user.token ]);

    const handleOnClick = (index, comment) => {
        if (window.confirm(`¿Realmente desea eliminar el comentario: ${comment}?`)) {
            comments.splice(index, 1);
            currentData.comments = comments;
            dispatch( updateCase(currentData,updateFunction, user.token) );
            //setLoadData(true);
        }
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            setLoadData(true);

            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Comentario eliminado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(currentData)
    }, [currentData]);

    return(
        <div className="w-100 d-flex">
            {Object.keys(currentData).length > 0?
                <div className="container d-flex flex-column">
                    <div className="w-100 mt-5">
                        <Link to={currentLink} className="back-button">&#60; Volver</Link>
                    </div>
                    <h1 className="my-5">Historial de seguimiento al caso</h1>
                    <span>Caso: <b>{currentData.caseType} - Exp {currentData.filingNumber} - Cliente {currentData.clientText}</b></span>
                    <div className="w-100 d-flex justify-content-end mt-3 mb-1">
                        <Link to={`${currentLink}/${params.id}/nuevo`} className="primary-button">Añadir un nuevo comentario</Link>
                    </div>
                    <table className="list-table my-3" style={{tableLayout: 'fixed'}}>
                        <thead>
                            <tr>
                                <th style={{width: 50}}>#</th>
                                <th className='date'>Fecha</th>
                                <th>Comentario</th>
                                <th style={{width: '25%'}}>Usuario</th>
                                <th style={{width: '10%'}}>Tipo</th>
                                <th style={{width: 50}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments.map((comment, index) => (
                                <tr key={index}>
                                    <td style={{width: 50}}> { (index+1) } </td>
                                    <td className='date'> <span className='inline-text'>{formatDate(comment.date, 2)}</span> </td>
                                    <td> {comment.comment} </td>
                                    <td style={{width: '25%'}}> {comment.creationUser.firstName} {comment.creationUser.lastName} </td>
                                    <td style={{width: '10%'}}> {comment.type} </td>
                                    <td style={{width: 50}}>
                                        <BsFillTrashFill onClick={()=>handleOnClick(index, comment.comment)} className='trash-icon' />
                                    </td>
                                </tr> 
                            ))}
                        </tbody>
                    </table>
                </div>
            :null}

        </div>
    );
}

export default CommentsList;
  